<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">

      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="openAddTemplatePopup">{{ $t('add_template') }}</vs-button>
      </template>
      <vs-divider></vs-divider>

    </vx-card>

    <vx-card id="messageTemplateDataContainer" :title="$tc('template', 2)" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-messages-tab-nav></shared-messages-tab-nav>
      </template>

      <shared-user-message-template-list
        :templates="templates"
        :displayCategoryLabel="true"
        :editTemplate="openEditTemplatePopup"
        :updateTemplate="updateMessageTemplate"
        :deleteTemplate="deleteTemplate">
      </shared-user-message-template-list>

    </vx-card>

    <modal :title="$t('add_message_template')" :active.sync="modals.add" size="md">
      <shared-add-message-template :categories="categoryOptions" @storeMessageTemplateSuccess="storeMessageTemplateSuccess"></shared-add-message-template>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="addTemplateButton" color="primary" type="filled" @click.prevent="storeMessageTemplate">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('edit_message_template')" :active.sync="modals.edit" size="md">
      <shared-edit-message-template
        :categories="categoryOptions"
        @updateMessageTemplateSuccess="updateMessageTemplateSuccess"
      ></shared-edit-message-template>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="editTemplateButton" color="primary" type="filled" @click.prevent="updateMessageTemplate">{{ $t('save') }}</vs-button>
      </div>
    </modal>
  </div>
</template>

<script>
import SharedMessagesTabNav from '@/views/Shared/Messages/TabNav'
import Template from '@/models/Template'
import SharedUserMessageTemplateList from '@/views/Shared/Messages/Templates/List'
import SharedAddMessageTemplate from '@/views/Shared/Messages/Templates/Add'
import SharedEditMessageTemplate from '@/views/Shared/Messages/Templates/Edit'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'

export default {
  name: 'User.Messages.Templates',
  components: {
    SharedMessagesTabNav,
    SharedUserMessageTemplateList,
    Modal,
    SharedAddMessageTemplate,
    SharedEditMessageTemplate
  },
  data () {
    return {
      templates: {},
      categoryOptions: [],

      modals: {
        add: false,
        edit: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        EventBus.$emit('initMessageTemplateFormData')
      }
    },
    'modals.edit' (val) {
      if (!val) {
        EventBus.$emit('initMessageTemplateFormData')
      }
    }
  },
  mounted () {
    this.loadMessageTemplates()
    this.$windowOpenerHelper.listenToPopUpMessage('reload_message_templates_table', this.loadMessageTemplates)
  },
  methods: {
    async loadMessageTemplates () {
      this.$vs.loading({container: '#messageTemplateDataContainer'})

      const response = await Template.all()
      this.templates = response.data.data.templates
      this.categoryOptions = response.data.meta.options.categories

      this.$vs.loading.close('#messageTemplateDataContainer > .con-vs-loading')
    },
    openEditTemplatePopup (data) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-message-template', { data }, this.editMessageTemplate)
    },
    addMessageTemplate () {
      this.modals.add = true
    },
    openAddTemplatePopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-message-template', {}, this.addMessageTemplate)
    },
    storeMessageTemplateSuccess () {
      this.loadMessageTemplates()
      this.modals.add = false
    },
    async storeMessageTemplate () {
      EventBus.$emit('storeMessageTemplate')
    },
    initMessageTemplateFormData () {
      EventBus.$emit('initMessageTemplateFormData')
    },
    async editMessageTemplate (data) {
      // TODO: Fix duplicate code on here and EditMessageTemplate
      const response = await Template.view({ id: data.id })
      EventBus.$emit('editMessageTemplate', response.data.template)
      this.modals.edit = true
    },
    updateMessageTemplateSuccess () {
      this.loadMessageTemplates()
      this.modals.edit = false
    },
    async updateMessageTemplate () {
      EventBus.$emit('updateMessageTemplate')
    },

    async deleteTemplate (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        const response = await Template.delete(id)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.loadMessageTemplates()
      }
    }
  }
}
</script>

<style scoped>

</style>
